import { computed, inject, input, signal } from '@angular/core';
import { AgentPromptListService } from 'AgentApp/ts/features/agent-prompt-list/services/agent-prompt-list.service';
import { UtilsService } from 'NewAngular/services/core/utils.service';
import { IconModule } from 'NewAngular/features/directives/icon/icon.module';
import { TooltipModule } from 'NewAngular/features/directives/popovers/tooltip/tooltip.module';
import { stripContextBlocks } from 'AgentApp/ts/utils/context-block';
import * as i0 from "@angular/core";
import * as i1 from "../../../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
import * as i2 from "../../../../../../../../../ycharts/static/ts/features/directives/popovers/tooltip/tooltip.directive";
function AgentUserMessageComponent_For_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2)(1, "div", 12)(2, "div", 13)(3, "div", 14)(4, "div", 15);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(5, "svg", 16);
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(6, "div", 17);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd()()()()();
} if (rf & 2) {
    const file_r1 = ctx.$implicit;
    i0.ɵɵadvance(7);
    i0.ɵɵtextInterpolate(file_r1.fileName);
} }
function AgentUserMessageComponent_Conditional_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 6);
} }
function AgentUserMessageComponent_Conditional_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "svg", 7);
} }
function AgentUserMessageComponent_Conditional_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "svg", 8);
} }
function AgentUserMessageComponent_Conditional_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "svg", 9);
} }
export class AgentUserMessageComponent {
    constructor() {
        this.agentPromptListService = inject(AgentPromptListService);
        this.utilsService = inject(UtilsService);
        this.messageText = input.required(...(ngDevMode ? [{ debugName: "messageText" }] : []));
        this.displayText = computed(() => stripContextBlocks(this.messageText()), ...(ngDevMode ? [{ debugName: "displayText" }] : []));
        this.files = input([], ...(ngDevMode ? [{ debugName: "files" }] : []));
        this.filesWithFileName = computed(() => {
            const files = this.files();
            return files.map((file) => ({ ...file, fileName: this.getFileName(file) }));
        }, ...(ngDevMode ? [{ debugName: "filesWithFileName" }] : []));
        this.saving = signal(false, ...(ngDevMode ? [{ debugName: "saving" }] : []));
        // Flipped once the user saves this message this session; renders the filled bookmark.
        this.saved = signal(false, ...(ngDevMode ? [{ debugName: "saved" }] : []));
        // Transient checkmark shown for ~2s right after saving, before settling on the filled bookmark.
        this.showSavedCheck = signal(false, ...(ngDevMode ? [{ debugName: "showSavedCheck" }] : []));
        this.copied = signal(false, ...(ngDevMode ? [{ debugName: "copied" }] : []));
    }
    getFileName(file) {
        return file.attachment_url.split('/').pop() || file.attachment_url;
    }
    savePrompt() {
        if (this.saving() || this.saved()) {
            return;
        }
        this.saving.set(true);
        this.agentPromptListService.createAgentPrompt({ prompt: this.displayText() }).subscribe({
            next: () => {
                this.saving.set(false);
                this.saved.set(true);
                this.showSavedCheck.set(true);
                setTimeout(() => {
                    this.showSavedCheck.set(false);
                }, 2000);
            },
            error: () => {
                this.saving.set(false);
            },
        });
    }
    copyText() {
        const contentCopied = this.utilsService.copyToClipboard(this.displayText());
        if (contentCopied && !this.copied()) {
            this.copied.set(true);
            setTimeout(() => {
                this.copied.set(false);
            }, 1300);
        }
    }
}
AgentUserMessageComponent.ɵfac = function AgentUserMessageComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AgentUserMessageComponent)(); };
AgentUserMessageComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AgentUserMessageComponent, selectors: [["ycn-agent-user-message"]], inputs: { messageText: [1, "messageText"], files: [1, "files"] }, decls: 14, vars: 8, consts: [[1, "pl-20", "mt-10"], [1, "plates", "plates-view-list", "mb-1", "text-right"], [1, "plate-container", "d-inline-flex"], [1, "text-large", "leading-aire", "mb-1", "text-prewrap", "text-right"], [1, "section-ai-request-actions"], ["ycnTooltip", "", 1, "btn", "btn-circle", "btn-xs", "btn-transparent", "btn-lightgray", 3, "click", "tooltipTitle", "tooltipPlacement", "disabled"], [1, "loader-spinner-context", "loader-xs"], ["ycnIcon", "", "name", "icon-check", "role", "img", 1, "text-blue-ada", "fill-current"], ["ycnIcon", "", "name", "icon-bookmark-filled", "role", "img", 1, "text-blue-ada", "fill-current"], ["ycnIcon", "", "name", "icon-bookmark", "role", "img"], ["ycnTooltip", "", 1, "btn", "btn-circle", "btn-xs", "btn-transparent", "btn-lightgray", 3, "click", "tooltipTitle", "tooltipPlacement"], ["ycnIcon", "", "role", "img", 3, "name"], [1, "plate", "plate-white"], [1, "plate-header", "width-full"], [1, "plate-title", "min-width-0"], [1, "plate-title-icon"], ["ycnIcon", "", "name", "icon-overview"], [1, "plate-title-name", "min-width-0", "text-ellipsis"]], template: function AgentUserMessageComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
        i0.ɵɵrepeaterCreate(2, AgentUserMessageComponent_For_3_Template, 8, 1, "div", 2, i0.ɵɵrepeaterTrackByIndex);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "div", 3);
        i0.ɵɵtext(5);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "div", 4)(7, "button", 5);
        i0.ɵɵlistener("click", function AgentUserMessageComponent_Template_button_click_7_listener() { return ctx.savePrompt(); });
        i0.ɵɵconditionalCreate(8, AgentUserMessageComponent_Conditional_8_Template, 1, 0, "div", 6)(9, AgentUserMessageComponent_Conditional_9_Template, 1, 0, ":svg:svg", 7)(10, AgentUserMessageComponent_Conditional_10_Template, 1, 0, ":svg:svg", 8)(11, AgentUserMessageComponent_Conditional_11_Template, 1, 0, ":svg:svg", 9);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(12, "button", 10);
        i0.ɵɵlistener("click", function AgentUserMessageComponent_Template_button_click_12_listener() { return ctx.copyText(); });
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelement(13, "svg", 11);
        i0.ɵɵelementEnd()()();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵrepeater(ctx.filesWithFileName());
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(ctx.displayText());
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("tooltipTitle", ctx.saved() ? "Saved prompt" : "Save prompt")("tooltipPlacement", "bottom")("disabled", ctx.saving() || ctx.saved());
        i0.ɵɵadvance();
        i0.ɵɵconditional(ctx.saving() ? 8 : ctx.showSavedCheck() ? 9 : ctx.saved() ? 10 : 11);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("tooltipTitle", ctx.copied() ? "Copied!" : "Copy")("tooltipPlacement", "bottom");
        i0.ɵɵadvance();
        i0.ɵɵproperty("name", ctx.copied() ? "icon-check" : "icon-copy");
    } }, dependencies: [IconModule, i1.IconDirective, TooltipModule, i2.TooltipDirective], encapsulation: 2, changeDetection: 0 });
